import React from 'react';
import { addDays, format } from 'date-fns';
import { de, enGB } from 'date-fns/esm/locale';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Image from '../../../../components/image/Image';
import { IMG_LOCATION } from '../../../../core/constants/api';
import { RootState } from '../../../../core/state/state';
import logo from '../../../../../img/logo.svg';

import './ToolbarPrintHeader.scss';

const ToolbarPrintHeader: React.FC = () => {
  const { t, i18n } = useTranslation();
  const project = useSelector((state: RootState) => state.projects.projectDetails);
  const firstDate = useSelector((state: RootState) => state.bookings.selectedDate);
  const secondDate = addDays(firstDate, 5);
  const locale = i18n.language === 'en-EN' ? enGB : de;
  const firstDateFormated = format(firstDate, 'w, dd.MMM', { locale });
  const secondDateFormated = format(secondDate, 'dd.MMM, yyyy', { locale });

  const dateString = `${t('booking.print.calendarWeekShort')} ${firstDateFormated} - ${secondDateFormated}`.toUpperCase();

  return (
    <div className="toolbar-print-header">
      <div className="d-flex">
        <Image className="toolbar-print-header__img" src={`${IMG_LOCATION}/${project?.image.fullName}`} alt={project?.image.name ?? ''} />
        <div className="d-flex flex-column ml-3">
          <span className="toolbar-print-header__name">{project?.name}</span>
          <div className="d-flex mt-1">
            <span className="toolbar-print-header__number">{dateString}</span>
            <span className="toolbar-print-header__area">{project?.code}</span>
          </div>
        </div>
      </div>
      <div>
        <Image className="toolbar-print-header__logo" src={logo} alt="logo" />
      </div>
    </div>
  );
};

export default ToolbarPrintHeader;
